export const migrations = {
  20230524: (state: any) => ({
    ...state,
    announcements: {
      list: [],
      categories: [],
      isLoading: false,
      error: null,
      ...state.announcements,
    },
    indexes: {
      families: {},
      indexes: [],
      indexList: [],
      eod: {},
      indexValues: [],
      indexValuesFirstSecond: [],
      assetClassOptions: [],
      indexTypeOptions: [],
      isLoading: false,
      error: "",
      ...state.indexes,
    },
  }),
  20230525: (state: any) => ({
    ...state,
    assets: {
      cryptocurrencies: [],
      isLoading: false,
      error: "",
    },
  }),
  20230526: (state: any) => ({
    ...state,
    indexes: {
      tokenPriceEod: {},
      ...state.indexes,
    },
  }),
  20230620: (state: any) => ({
    ...state,
    indexes: {
      history: [],
      ...state.indexes,
    },
  }),
  20230809: (state: any) => ({
    ...state,
    indexes: {
      indexLab: [],
      ...state.indexes,
    },
  }),
  20230912: (state: any) => ({
    ...state,
    news: {
      list: [],
      isLoading: false,
      error: "",
    },
  }),
};
